module.exports = __webpack_public_path__ + "static/img/dataserviceIndex_3.6d7c3f91.svg";